import React, { FC } from 'react';
import { hasExternalForm } from '@/helpers/externalForm';
import { ModalName } from '@/common/contexts/globalModalContext';
import ArticlePreviewLayout, {
  ArticlePreviewLayoutProps,
} from '@/common/layouts/ArticlePreviewLayout/ArticlePreviewLayout';
import SidebarCard, { SidebarProps } from '@/pages/MarketReportsPreviewPage/components/SidebarCard/SidebarCard';
import PackageOptions, {
  PackageOptionsProps,
} from '@/pages/MarketReportsPreviewPage/components/PackageOptions/PackageOptions';
import PackageDescriptions, {
  PackageDescriptionsProps,
} from '@/pages/MarketReportsPreviewPage/components/PackageDescriptions/PackageDescriptions';
import Banner from '@/pages/MarketReportsPreviewPage/components/Banner/Banner';
import MarketReportModal, {
  MarketReportModalProps,
} from '@/pages/MarketReportsPreviewPage/components/MarketReportModal/MarketReportModal';
import ExternalModalForms from '@/common/components/Modal/ExternalModalForms/ExternalModalForms';
import styles from './MarketReportsPreviewPage.module.scss';

interface MarketReportsPreviewPageProps extends ArticlePreviewLayoutProps, PackageDescriptionsProps {
  topSection?: {
    link: string;
    title: string;
    description: string;
  };
  slider?: SidebarProps;
  table?: PackageOptionsProps;
  marketReportPopup?: MarketReportModalProps;
}

const backToTopButtonProps = {
  shouldBeHiddenInViewport: {
    mobile: true,
    tablet: true,
  },
};

const MarketReportsPreviewPage: FC<MarketReportsPreviewPageProps> = ({
  topSection,
  slider,
  table,
  blocks,
  pageHeader = {},
  marketReportPopup,
  pardot,
  ...articleLayoutProps
}) => {
  const {
    downloadButton,
    ...reportPoster
  } = slider || {};
  const sidebarContent = !!slider && <SidebarCard {...slider} imageUrls={pageHeader?.backgroundImages} />;

  const articlePreviewProps = {
    ...articleLayoutProps,
    sidebarContent,
    title: topSection?.title,
    date: topSection?.link,
    pageHeader,
    backToTopButtonProps,
  };

  const { backgroundImages } = pageHeader;

  const renderModal = () => {
    if (!marketReportPopup || hasExternalForm({ pardot, modalName: ModalName.marketReport })) {
      return null;
    }

    return (
      <MarketReportModal
        {...marketReportPopup}
        {...reportPoster}
        imageUrls={backgroundImages}
      />
    );
  };

  return (
    <ArticlePreviewLayout {...articlePreviewProps}>
      <div className={styles.description}>
        {topSection?.description}
      </div>
      {!!table && (
        <PackageOptions {...table} />
      )}
      <PackageDescriptions blocks={blocks} />
      {!!slider && (
        <Banner {...slider} imageUrls={backgroundImages} />
      )}
      {!!pardot && (
        <ExternalModalForms
          pardot={pardot}
          titles={{
            [ModalName.marketReport]: marketReportPopup?.modalWindowTitle,
          }}
        />
      )}
      {renderModal()}
    </ArticlePreviewLayout>
  );
};

export default MarketReportsPreviewPage;
